import React from 'react';

const StatCard = ({ title, value, icon, trend, trendValue, color }) => {
  const getColorTheme = (colorName) => {
    switch (colorName) {
      case 'gold': return { text: 'text-[#e5b76b]', bg: 'bg-[#3b271d]' };
      case 'cyan': return { text: 'text-[#f472b6]', bg: 'bg-[#34122d]' };
      case 'pink': return { text: 'text-[#f472b6]', bg: 'bg-[#34122d]' };
      case 'purple': return { text: 'text-[#f472b6]', bg: 'bg-[#2b1636]' };
      case 'magenta': return { text: 'text-[#f472b6]', bg: 'bg-[#2b1636]' };
      default: return { text: 'text-white', bg: 'bg-white/5' };
    }
  };

  const theme = getColorTheme(color);

  return (
    <div
      className="relative bg-white/[0.04] border border-white/10 p-6 rounded-2xl overflow-hidden group/stat shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:bg-white/[0.06] transition-colors"
    >
      <div className="flex items-center gap-4 relative z-10 w-full">
        {/* Exact Icon Container */}
        <div 
          className={`w-[60px] h-[60px] rounded-full flex-shrink-0 flex items-center justify-center ${theme.bg} relative`}
        >
          <i className={`${icon} text-2xl ${theme.text} relative z-10`}></i>
        </div>
        
        <div className="flex-1 min-w-0 flex flex-col justify-center">
          <p className="text-xs font-normal text-secondaryText mb-1">{title}</p>
          <h3 className="text-[28px] font-bold text-white leading-none stat-value truncate">{value}</h3>
          
          {/* Trend Badge */}
          <div className="flex items-center gap-1 mt-2">
            <i className={`ri-arrow-${trend === 'up' ? 'up' : 'down'}-line ${trend === 'up' ? 'text-accent-pink' : 'text-danger'} text-[10px]`}></i>
            <span className={`${trend === 'up' ? 'text-accent-pink' : 'text-danger'} text-[10px] font-medium`}>{trendValue}%</span>
            <span className="text-[10px] text-secondaryText ml-1">from last month</span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default StatCard;
